import { useCallback } from 'react'

import axios from 'axios'

import { auth } from 'services/firebase'
import { firebaseBaseURL } from 'utils/constants'

import useGetLawyerStripeAccountId from '../lawyers/useGetLawyerStripeAccountId'

const useGenerateOnBoardingLink = () => {
  const doGetLawyerStripeAccountId = useGetLawyerStripeAccountId()

  return useCallback(async () => {
    if (!auth) return false

    const { uid } = auth.currentUser

    const test = await doGetLawyerStripeAccountId(uid)
    const axiosConfig = {
      method: 'post',
      url: `${firebaseBaseURL}stripe/get-onboarding-link`,
      data: { account_id: test.account_id },
      headers: {
        'Content-Type': 'application/json',
      },
    }

    return axios(axiosConfig)
      .then((result) => {
        if (result) {
          return result.data
        }
      })
      .catch(() => {
        throw 'Error'
      })
  }, [])
}

export default useGenerateOnBoardingLink
